import { ranking } from '@/mocks/homeData';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  stable: 'ri-subtract-line',
  new: 'ri-sparkling-line',
};

const trendColors: Record<string, string> = {
  up: 'text-primary-500',
  stable: 'text-foreground-400',
  new: 'text-accent-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 scroll-mt-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 bg-accent-100 rounded-full mb-3">热门榜单</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门排行</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">基于阅读量、讨论度和好评率综合计算的热门漫画排行</p>
        </div>

        <div className="max-w-4xl mx-auto">
          {ranking.map((item, index) => (
            <a key={item.rank} href="#cards" className="group flex items-center gap-4 p-4 border-b border-background-200 last:border-b-0 hover:bg-background-100 transition-colors cursor-pointer no-underline">
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                index < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-heading font-bold text-sm text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                  <span className="text-[11px] text-foreground-400">{item.type}</span>
                  <span className={`flex items-center gap-0.5 text-xs ${trendColors[item.trend] || 'text-foreground-400'}`}>
                    <i className={trendIcons[item.trend] || 'ri-subtract-line'}></i>
                  </span>
                </div>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="font-heading font-bold text-lg text-primary-600">{item.heat}</div>
                <div className="text-[10px] text-foreground-400">综合热度</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}